import {
  products as productEntities,
  getProductsForGrid as getProductsForGridEntities,
} from "../data/entity_sets/products";
import type { FaireProductEntity } from "@faire/playground-entity-db/entity_types/product";
import { getEntityByToken } from "../data/get_entity";

export type DisplayProductEntity = FaireProductEntity & {
  price: string;
  msrp?: string;
  minOrder?: string;
  isTopShop?: boolean;
  rating?: number;
  reviewCount?: number;
  brandAvatarUrl?: string;
};

const toMoneyString = (value?: number | string): string | undefined => {
  if (value === undefined) {
    return undefined;
  }
  if (typeof value === "string") {
    return value;
  }
  return `$${value.toFixed(2)}`;
};

export const toDisplayProduct = (
  product: FaireProductEntity
): DisplayProductEntity => {
  const brand = product.brandToken
    ? getEntityByToken(product.brandToken, "brand")
    : undefined;
  const minOrder =
    brand?.minimumOrderDollars !== undefined
      ? `$${brand.minimumOrderDollars.toFixed(0)} min`
      : product.caseSize
        ? `Case of ${product.caseSize}`
        : undefined;
  return {
    ...product,
    price: toMoneyString(product.priceDollars) ?? "$0.00",
    msrp: toMoneyString(product.msrpDollars),
    minOrder,
    isTopShop: brand?.isTopShop,
    rating: brand?.rating,
    reviewCount: brand?.reviewCount,
    brandAvatarUrl: brand?.avatarUrl,
  };
};

export const products: DisplayProductEntity[] =
  productEntities.map(toDisplayProduct);

export const getProductsForGrid = (
  rows: number,
  columns: number = 6
): DisplayProductEntity[] => {
  return getProductsForGridEntities(rows, columns).map(toDisplayProduct);
};

export const brandNameToSlug = (brandName: string): string => {
  return brandName.toLowerCase().replace(/\s+/g, "-");
};
